import React from 'react'
import Input from 'components/Input/Input/Input'
import Button from 'components/Button'

import cn from 'classnames'
import s from './InputWithConfirm.scss'

export default props => {
  const {
    meta,
    input: { value },
    type, // 'email' or 'tel'
    confirmation, // confirmation token from user (either emailConfirmation or phoneConfirmation)
    showConfirmationCodeFormModal,
  } = props

  const info =
    !confirmation?.isConfirmed || meta.dirty
      ? '<b>Important!</b> You are required to confirm this ' + (type === 'email' ? 'email' : 'number')
      : ''

  const showForm = () => {
    showConfirmationCodeFormModal({
      type,
      sendOnShow: meta.dirty || !confirmation.isSent,
      recipient: value,
    })
  }

  // In order to make React happy we will remove showConfirmationCodeFormModal from props for Input.
  // Fixes this:
  // >> Warning: React does not recognize the `showConfirmationCodeFormModal` prop on a DOM element.
  const removeProperty = (propKey, { [propKey]: propValue, ...rest }) => rest

  return (
    <Input {...removeProperty('showConfirmationCodeFormModal', props)} info={info}>
      {confirmation?.isConfirmed && meta.pristine ? (
        <div className={cn(s.button, s.confirmed)}>Confirmed</div>
      ) : (
        <Button
          className={cn(s.button)}
          size="xs"
          color="warn"
          disabled={meta.invalid}
          onClick={showForm}
        >
          Confirm
        </Button>
      )}
    </Input>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/InputWithConfirm/InputWithConfirm.jsx